import http from "@/utils/request";

const stock = {
  getStockList: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuStockService.querySkuStock4Page",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  submitDownloadBatchStockTask: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.submitDownloadBatchStockTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  //  导入库存预览
  previewBatchImportSkuStockAdjust: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuStockService.previewBatchImportSkuStockAdjust",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 批量导入库存
  batchAdjustStock: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuStockService.batchAdjustStock",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 单个导入库存
  adjustStock: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuStockService.adjustStock",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

const purchase = {
  getPurchase: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderPurchaseOrderService.queryPurchaseOrder4Page",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  confirmPurchaseOrder: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderPurchaseOrderService.confirmPurchaseOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

const stockin = {
  getStockinList: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderStockinOrderService.queryStockinOrder4Page",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  getStockinDetail: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderStockinOrderService.getStockinOrderDetailInfo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  saveCallbackInfo: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderStockinOrderService.saveInfo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

const carrier = {
  queryCarrier: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderWarehouseService.queryCarrierList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

// 渠道库存
const merchantStock = {
  queryMerchantStock: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderChannelStockService.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  downloadMerchantStock: (data) =>
    http.sendRequest({
      METHOD_NAME:
        "venderChannelStockService.submitDownloadVenderChannelStockTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default {
  ...stock,
  ...purchase,
  ...stockin,
  ...carrier,
  ...merchantStock,
};
